export const USER_ANALYTICS_CHART_NAMES = ['weekly_active_users'] as const;

export const DELIVERY_NOTE_ANALYTICS_CHART_NAMES = ['weekly_dlns'] as const;

export const ANALYTICS_CHART_NAMES = [
  ...DELIVERY_NOTE_ANALYTICS_CHART_NAMES,
  ...USER_ANALYTICS_CHART_NAMES,
] as const;

export const ANALYTICS_CHART_AGGREGATION = ['day', 'week', 'month'] as const;

export const ANALYTICS_CHART_TYPES = ['distribution', 'time_series'] as const;
